import { Box, Typography, CircularProgress } from '@mui/material'
import { Error as ErrorIcon } from '@mui/icons-material'
import { designSpecs } from '../../theme/designSpecs'
import Button from '../common/Button'
import ResultsGrid from './ResultsGrid'
import ExamplePrompts from './ExamplePrompts'

const PreviewPanel = ({
  state, // 'empty' | 'uploaded' | 'loading' | 'results' | 'error'
  results,
  errorMessage,
  onRegenerate,
  onDownloadAll,
  onRetry,
}) => {
  return (
    <Box
      sx={{
        width: '50%',
        bgcolor: 'grey.50',
        p: 4,
        overflowY: 'auto',
        height: 'calc(100vh - 80px)',
      }}
    >
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        {/* Example Prompts State */}
        {(state === 'empty' || state === 'uploaded') && <ExamplePrompts />}

        {/* Loading State */}
        {state === 'loading' && (
          <Box
            sx={{
              textAlign: 'center',
              py: 10,
            }}
          >
            <CircularProgress
              size={64}
              sx={{
                mb: 3,
                color: 'primary.main',
              }}
            />
            <Typography variant="h4" sx={{ color: 'grey.700', mb: 1.5, fontWeight: 600 }}>
              Creating your images...
            </Typography>
            <Typography variant="body1" sx={{ color: 'grey.500' }}>
              This usually takes 30-60 seconds
            </Typography>
          </Box>
        )}

        {/* Results State */}
        {state === 'results' && results && results.length > 0 && (
          <ResultsGrid
            results={results}
            onRegenerate={onRegenerate}
            onDownloadAll={onDownloadAll}
          />
        )}

        {/* Error State */}
        {state === 'error' && (
          <Box
            sx={{
              textAlign: 'center',
              py: 10,
            }}
          >
            <ErrorIcon
              sx={{
                fontSize: 96,
                color: 'error.light',
                mb: 3,
              }}
            />
            <Typography variant="h4" sx={{ color: 'grey.700', mb: 2, fontWeight: 600 }}>
              Something went wrong
            </Typography>
            <Typography variant="body1" sx={{ color: 'grey.500', mb: 3, maxWidth: 500, mx: 'auto' }}>
              {errorMessage || "We couldn't generate your images. Please try again."}
            </Typography>
            <Button
              variant="contained"
              onClick={onRetry}
              sx={{
                background: designSpecs.gradients.primary,
                px: 4,
                py: 1.5,
                '&:hover': {
                  background: designSpecs.gradients.primary,
                },
              }}
            >
              Try Again
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default PreviewPanel
